import { render, staticRenderFns } from "./GeneralPage.vue?vue&type=template&id=033b4d00&scoped=true"
import script from "./GeneralPage.vue?vue&type=script&lang=js"
export * from "./GeneralPage.vue?vue&type=script&lang=js"
import style0 from "./GeneralPage.vue?vue&type=style&index=0&id=033b4d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b4d00",
  null
  
)

export default component.exports